<template>
    <div
        class="modal fade right"
        id="share_modal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="ページをシェアする"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog-centered modal-fullscreen-md-down" role="document">
            <div class="modal-content">
                <div class="modal-header text-center">
                    シェアする
                    <button type="button" class="btn-close" data-mdb-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body text-center" v-if="node">
                    <div class="mb-1">{{ node.name }}</div>
                    <img :src="node.node_image" :alt="node.name" class="rounded-1 mb-2 w-50 mx-auto" />
                    <p class="text-start small" v-html="sanitize(node.description)"></p>
                    <hr />
                    <div class="mb-2">シェアする</div>
                    <share-buttons-business :node="node" v-if="node_type == 14"/>
                    <share-buttons :node="node" v-else/>
                </div>
                <div class="modal-footer">
                    <slot name="footer"></slot>
                    <a href="#" class="btn btn-default" data-mdb-dismiss="modal">閉じる</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import sanitizeHTML from 'sanitize-html';
import utils from '@js/modules/utils/utils';
import ShareButtons from './ShareButtons.vue';
import ShareButtonsBusiness from './ShareButtonsBusiness.vue';

export default defineComponent({
    name: 'ShareModal',
    props: {
        node: {
            type: Object,
            default: null,
        },
    },
    data: () => {
        return {
            mode: 'data',
            qr_color: 'black',
            size: 244,
            qr_type: 'normal',
        };
    },
    computed:{
      node_type(){
          if(this.node && this.node.node_type){
              return this.node.node_type;
          }else{
              return 0;
          }
      }
    },
    components: {
        ShareButtons,
        ShareButtonsBusiness
    },
    methods: {
        sanitize(str) {
            return utils.nl2br(sanitizeHTML(str));
        },
    },
});
</script>
